import React from 'react';
import PropTypes from 'prop-types';
import AlertNotice from 'shared/components/alert-notice/AlertNotice';

export function WhatsNewBanner({ onLearnMore }) {
  return (
    <AlertNotice
      message={"New features are available in TCM. <button class='btn-link ms-2'>Learn more</button>"}
      type="information"
      onClick={onLearnMore}
    />
  );
}

WhatsNewBanner.propTypes = {
  onLearnMore: PropTypes.func.isRequired,
};
